// extracted by mini-css-extract-plugin
export default {"chargers-list":"NewBookingBlock_chargers-list__yDXyl","new-booking-block":"NewBookingBlock_new-booking-block__z1-6l","new-booking-item":"NewBookingBlock_new-booking-item__jNK0e"};